// Cascade a master (project-level) value onto the canvas section objects.
//
// Bug this fixes: each section object stores its OWN `key`/`tempo`, snapshotted
// from the project value at generation time. Changing the master Key (or BPM)
// dropdown updated only the project-level state — the section cards kept rendering
// their stale baked-in value, so a mis-detected key could not actually be corrected.
// These helpers re-sync every section object so the master control drives the cards.
//
// Only objects with type === 'section' carry key/tempo; sticky notes and other
// canvas objects are left untouched.

export function applyKeyToSections(objects, key) {
  if (!Array.isArray(objects)) return objects;
  return objects.map((o) => (o && o.type === 'section' ? { ...o, key } : o));
}

export function applyTempoToSections(objects, tempo) {
  if (!Array.isArray(objects)) return objects;
  return objects.map((o) => (o && o.type === 'section' ? { ...o, tempo } : o));
}
